<template lang="pug">
  .tour-info
    b-row
      b-col(col lg="9")
        h2 {{title}}
        b-row
          b-col
            p(v-html="date_info")
          b-col
            p(v-html="tourists_info")
      b-col(col lg="3")
        .float-right
          order-status-badge(:status="status")

</template>

<script>
import OrderStatusBadge from "../shared/OrderStatusBadge";
import moment from 'moment';
import { humanized_tourists } from "../../../components/shared/helpers";

export default {
  name: "tour_info",
  components: {OrderStatusBadge},
  props:{
    adults: String,
    ages: String,
    status: String,
    title: String,
    date: [Date, String],
  },
  computed:{
    humanized_date(){
      return moment(this.date).format('LL')
    },
    date_info(){
      return `Дата выезда: <b>${this.humanized_date}</b>`
    },
    tourists_info(){
      return `Туристы: <b>${humanized_tourists(this.adults, this.ages)}</b>`
    },
  }
}
</script>

<style scoped>

</style>